// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 354) return "dist/354.js";
	if (chunkId === 418) return "dist/418.js";
	if (chunkId === 332) return "dist/332.js";
	// return url for filenames based on template
	return undefined;
};